<script setup lang="ts">
defineProps<{
  failedCount: number;
  isExpiration: boolean;
}>();
</script>

<template>
  <div class="partial-failure-banner" role="alert">
    <svg
      width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.3 1.55 18.65 1.55 19C1.55 19.35 1.65 19.7 1.82 20C2 20.3 2.25 20.56 2.55 20.73C2.85 20.91 3.19 21 3.54 21H20.46C20.81 21 21.15 20.91 21.45 20.73C21.75 20.56 22 20.3 22.18 20C22.35 19.7 22.45 19.35 22.45 19C22.45 18.65 22.36 18.3 22.18 18L13.71 3.86C13.53 3.56 13.28 3.32 12.98 3.15C12.68 2.98 12.34 2.89 12 2.89C11.66 2.89 11.32 2.98 11.02 3.15C10.72 3.32 10.47 3.56 10.29 3.86Z"
        stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      />
    </svg>
    <p class="partial-failure-title">
      {{ isExpiration ? $t('cart.partialFailure.titleExpired', failedCount) : $t('cart.partialFailure.title', failedCount) }}
    </p>
  </div>
</template>

<style scoped lang="css">
.partial-failure-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--yb-spacing-sm);
  text-align: center;
  padding: var(--yb-spacing-base) var(--yb-spacing-sm);

  > svg {
    flex-shrink: 0;
  }
}

.partial-failure-title {
  font-weight: var(--yb-text-bold);
  margin: 0;
}
</style>
